export default __webpack_public_path__ + "static/media/speakers.442f9c54.png";